export enum checkoutMode {
    stripe = 0,
    coinbase = 1
}